import { render, staticRenderFns } from "./FixedBillingRateList.vue?vue&type=template&id=2474e54a&scoped=true&lang=pug"
import script from "./FixedBillingRateList.vue?vue&type=script&lang=js"
export * from "./FixedBillingRateList.vue?vue&type=script&lang=js"
import style0 from "./FixedBillingRateList.vue?vue&type=style&index=0&id=2474e54a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474e54a",
  null
  
)

export default component.exports